import * as React from 'react';
import { GlobalizationContext } from '../globalization/GlobalizationContext';
/**
 * A custom [React Hook](https://reactjs.org/docs/hooks-intro.html) providing access to an [LocalizationService]({% slug api_intl_localizationservice %}).
 */
export var useLocalization = function () { return React.useContext(GlobalizationContext).localization; };
